import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaDot',
})
export class CommaDotPipe implements PipeTransform {
    transform(value: string): string {
        if (value) {
            return (value + '').replace(',', '.');
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/comma-dot.pipe.ts